"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var react_animate_height_1 = __importDefault(require("react-animate-height"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Headline_1 = require("../../atoms/Headline");

var Icon_1 = require("../../atoms/Icon");

var AccordionStateful_1 = require("./AccordionStateful");

exports.Accordion = function (_a) {
  var id = _a.id,
      title = _a.title,
      children = _a.children,
      className = _a.className,
      isOpen = _a.isOpen,
      onChange = _a.onChange,
      onKeyDown = _a.onKeyDown,
      refCallback = _a.refCallback,
      asDescriptionItems = _a.asDescriptionItems;
  var TitleComponent = asDescriptionItems ? "dt" : "div";
  var BodyComponent = asDescriptionItems ? "dd" : "div";
  var dtClassNames = utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "accordion-header", !isOpen && "closed", className]);
  var uuid = id || uniqid_1["default"]("accordion-");
  var AccordionInner = React.createElement(React.Fragment, null, React.createElement(TitleComponent, {
    id: uuid,
    role: "heading",
    className: dtClassNames,
    "aria-level": 3
  }, React.createElement("button", {
    type: "button",
    id: uuid + "-header-btn",
    "aria-controls": uuid + "-content",
    "aria-expanded": isOpen,
    onClick: function onClick(ev) {
      return onChange && onChange(!isOpen, id, ev);
    },
    ref: function ref(curr) {
      return refCallback && refCallback(curr);
    },
    onKeyDown: onKeyDown
  }, React.createElement(Headline_1.Headline, {
    asSpan: true,
    size: Headline_1.Headline.Sizes.H4,
    className: CSSPrefix_1.lsgPre + "accordion-header-text"
  }, title), React.createElement(Icon_1.Icon, {
    className: CSSPrefix_1.lsgPre + "accordion-header-icon",
    name: Icon_1.Icon.Names.interaction_arrows_chevronUp
  }))), React.createElement(react_animate_height_1["default"], {
    duration: 300,
    height: isOpen ? "auto" : 0,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "accordion-content-container", isOpen && " " + CSSPrefix_1.lsgPre + "accordion-content-container__open"])
  }, React.createElement(BodyComponent, {
    id: uuid + "-content",
    className: CSSPrefix_1.lsgPre + "accordion-content",
    "aria-labelledby": "" + uuid
  }, children)));
  return asDescriptionItems ? AccordionInner : React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "accordion__standalone"
  }, AccordionInner);
};

exports.Accordion.Stateful = AccordionStateful_1.AccordionStateful;
exports.Accordion.displayName = "Accordion";